import React from 'react'
import AOSInit from '../../components/Animation/AOSInit'
import NavBarHome from '../../components/NavBar/NavBarHome'
import Footer from '../../components/Footer/Footer'
import Masthead from './Masthead'
import ProgramPresentation from './ProgramPresentation'
import SubscriptionPlans from './SubscriptionPlans'
import AvailablePacks from './AvailablePacks'
import SchoolBenefits from './SchoolBenefits'
import Testimonials from './Testimonials'
import FinalCallToAction from './FinalCallToAction'

function SchoolOffer() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen overflow-x-hidden">
         <AOSInit />

         <NavBarHome />

         <Masthead />
         <ProgramPresentation />
         <SubscriptionPlans />
         <AvailablePacks />
         <SchoolBenefits />
         <Testimonials />
         <FinalCallToAction />

         {/* Footer */}
         <section id="footer">
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-[#140342]"
               textColor="text-white"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default SchoolOffer